module.exports = __webpack_public_path__ + "img/logo.671b0781.svg";